import { createComponent } from '@front/utils/alpine';
const Sample = createComponent(() => ({
    isProductSelectActive: false,
    input: '',
    results: [],
    selectedProduct: {},
    formError: '',
    setSelectedProduct(product) {
        this.selectedProduct.id = product.id ?? 0;
        this.selectedProduct.brand = product.brand?.title ?? '';
        this.selectedProduct.short_description =
            product.short_description ?? '';
        this.selectedProduct.name = product.name ?? '';
        this.selectedProduct.reference = product.reference ?? '';
        this.selectedProduct.media = product.first_media ?? '';
        this.input = this.selectedProduct.reference;
    },
    cleanSelectedProduct() {
        this.selectedProduct.id = 0;
        this.selectedProduct.brand = '';
        this.selectedProduct.short_description = '';
        this.selectedProduct.name = '';
        this.selectedProduct.reference = '';
        this.input = '';
    },
    async searchProduct() {
        try {
            const app = JSON.parse(document
                .querySelector('meta[name="app"]')
                .getAttribute('content'));
            const csrfToken = app.token;
            const response = await fetch(app.sample.urls.search, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken || '',
                },
                body: JSON.stringify({
                    query: this.input,
                }),
            });
            if (response.ok) {
                const data = await response.json();
                this.results = data.data;
            }
            else {
                console.error('Erreur lors de la recherche des produits');
            }
        }
        catch (error) {
            console.error('Erreur réseau :', error);
        }
    },
    /*
    validateForm() {
        this.formError = '';
        if (
            this.selectedProduct.id === undefined ||
            this.selectedProduct.id === 0
        ) {
            this.formError = 'Veuillez sélectionner un produit.';
            return false;
        }
        return true;
    },
    */
}));
export { Sample };
